/* ============================================================
   RUYA - Theme JavaScript v3
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- NAV SCROLL ----
  var nav = document.getElementById('main-nav');
  if (nav) {
    var onScroll = function() { nav.classList.toggle('scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- MOBILE MENU ----
  var burger      = document.getElementById('nav-burger');
  var mobileMenu  = document.getElementById('mobile-menu');
  var mobileOver  = document.getElementById('mobile-menu-overlay');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    if (burger) burger.classList.add('open');
    if (mobileOver) mobileOver.classList.add('open');
    if (nav) nav.classList.add('menu-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    if (burger) burger.classList.remove('open');
    if (mobileOver) mobileOver.classList.remove('open');
    if (nav) nav.classList.remove('menu-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Reset all accordions back to closed state every time
    document.querySelectorAll('.mobile-menu-accordion').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.mobile-menu-sub').forEach(function(sub) {
      sub.classList.remove('open');
    });
    document.querySelectorAll('.mobile-menu-item--has-children').forEach(function(li) {
      li.classList.remove('submenu-open');
    });
  }

  if (burger && mobileMenu) {
    burger.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.contains('open');
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
    if (mobileOver) mobileOver.addEventListener('click', closeMobileMenu);
  }

  // ---- MOBILE ACCORDION (Collections submenu) ----
  document.querySelectorAll('.mobile-menu-accordion').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      var sub = this.nextElementSibling;
      var parentLi = this.closest('.mobile-menu-item--has-children');

      // Close any other open accordions first
      document.querySelectorAll('.mobile-menu-accordion[aria-expanded="true"]').forEach(function(other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var otherSub = other.nextElementSibling;
          var otherLi = other.closest('.mobile-menu-item--has-children');
          if (otherSub) otherSub.classList.remove('open');
          if (otherLi) otherLi.classList.remove('submenu-open');
        }
      });

      // Toggle this one
      var nowExpanded = !isExpanded;
      this.setAttribute('aria-expanded', String(nowExpanded));
      if (sub) sub.classList.toggle('open', nowExpanded);
      if (parentLi) parentLi.classList.toggle('submenu-open', nowExpanded);
    });
  });

  // ---- SEARCH ----
  var searchOverlay = document.getElementById('search-overlay');
  var searchClose   = document.getElementById('search-close');
  document.querySelectorAll('.nav-search-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchOverlay) {
        searchOverlay.classList.add('open');
        var input = searchOverlay.querySelector('.search-input');
        if (input) input.focus();
      }
    });
  });
  if (searchClose) searchClose.addEventListener('click', function() {
    searchOverlay.classList.remove('open');
  });

  // ---- CART DRAWER ----
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartOpenBtn = document.getElementById('cart-open-btn');
  var cartCloseBtn= document.getElementById('cart-close-btn');

  function openCart() {
    if (cartDrawer)  cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer)  cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartOpenBtn) cartOpenBtn.addEventListener('click', function(e) {
    e.preventDefault();
    openCart();
  });
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay)  cartOverlay.addEventListener('click', closeCart);

  // ---- CHECKOUT ----
  // Clear body overflow lock before navigating to checkout
  var checkoutBtn = document.getElementById('cart-checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      document.body.style.overflow = '';
    });
  }

  // ---- CART MONEY FORMAT ----
  // Shopify AJAX cart API returns prices in cents (integers)
  // e.g. PKR 2500.00 is returned as 250000
  function formatMoney(cents) {
    var amount = Math.round(cents) / 100;
    return 'PKR ' + amount.toLocaleString('en-PK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  // ---- UPDATE CART DRAWER UI ----
  // Exposed globally so product page inline script can call it too
  function updateCartDrawer(cart) {
    var countEl = document.getElementById('cart-count');
    var totalEl = document.getElementById('cart-total');
    var itemsEl = document.getElementById('cart-items');
    var emptyEl = document.getElementById('cart-empty');

    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      if (itemsEl) itemsEl.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function(item, index) {
        var unitPrice = formatMoney(item.final_price);
        var linePrice = item.quantity > 1
          ? ' <span class="cart-item-line-total">(' + formatMoney(item.final_line_price) + ')</span>'
          : '';
        return '<div class="cart-item" data-key="' + item.key + '" data-qty="' + item.quantity + '" data-line="' + (index + 1) + '">' +
          (item.image ? '<img src="' + item.image + '" class="cart-item-img" alt="' + item.product_title + '">' : '') +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + item.product_title + '</div>' +
            '<div class="cart-item-variant">' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
            '<div class="cart-item-price">' + unitPrice + linePrice + '</div>' +
          '</div>' +
          '<div class="cart-item-actions">' +
            '<div class="cart-item-qty">' +
              '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="qty-btn" data-action="increase" data-key="' + item.key + '">+</button>' +
            '</div>' +
            '<button class="cart-item-remove" data-key="' + item.key + '">&times;</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }
  }
  // Make available globally for product page script
  window.ruyaUpdateCart = updateCartDrawer;

  // ---- CART ITEM QUANTITY & REMOVE ----
  document.addEventListener('click', function(e) {
    var qtyBtn    = e.target.closest('.qty-btn');
    var removeBtn = e.target.closest('.cart-item-remove');

    if (qtyBtn) {
      var action   = qtyBtn.dataset.action;
      var cartItem = qtyBtn.closest('.cart-item');
      if (!cartItem) { console.log('RUYA: no .cart-item parent found'); return; }

      var line    = Number(cartItem.getAttribute('data-line'));
      var current = Number(cartItem.getAttribute('data-qty'));
      console.log('RUYA qty click — action:', action, '| line:', line, '| current qty:', current, '| data-line attr:', cartItem.getAttribute('data-line'), '| data-qty attr:', cartItem.getAttribute('data-qty'));

      if (!current || current < 1) current = 1;
      var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      console.log('RUYA: sending line:', line, 'quantity:', newQty);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
      .then(function(r) {
        console.log('RUYA: /cart/change.js status:', r.status);
        return r.json();
      })
      .then(function(updatedCart) {
        console.log('RUYA: updatedCart response:', updatedCart);
        if (updatedCart.items) {
          updateCartDrawer(updatedCart);
        } else {
          console.log('RUYA: no items in response, fetching /cart.js');
          fetch('/cart.js').then(function(r) { return r.json(); }).then(updateCartDrawer);
        }
      });
    }

    if (removeBtn) {
      var cartItem = removeBtn.closest('.cart-item');
      var line = cartItem ? Number(cartItem.getAttribute('data-line')) : null;
      if (!line) { console.log('RUYA: remove — no line found'); return; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.items !== undefined) {
          updateCartDrawer(cart);
        } else {
          fetch('/cart.js').then(function(r) { return r.json(); }).then(updateCartDrawer);
        }
      });
    }
  });

  // ---- QUICK ADD (Collection grid) ----
  document.querySelectorAll('.quick-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var self = this;
      self.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() { return fetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        self.textContent = 'Added';
        updateCartDrawer(cart);
        openCart();
        setTimeout(function() { self.textContent = 'Quick Add'; }, 2000);
      });
    });
  });

  // ---- EMAIL SIGNUP ----
  document.addEventListener('submit', function(e) {
    if (!e.target.classList.contains('email-signup-form')) return;
    e.preventDefault();
    var form  = e.target;
    var input = form.querySelector('.email-input');
    var btn   = form.querySelector('.email-btn');
    var val   = input ? input.value.trim() : '';
    if (!val || !val.includes('@')) {
      if (input) input.style.borderColor = 'rgba(193,146,122,0.6)';
      return;
    }
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=customer&email=' + encodeURIComponent(val) + '&contact[tags]=newsletter'
    }).finally(function() {
      if (btn) { btn.textContent = 'Joined'; btn.style.background = '#2c3326'; }
      if (input) { input.value = ''; input.placeholder = 'Thank you for joining'; }
      setTimeout(function() {
        if (btn) { btn.textContent = 'Join'; btn.style.background = ''; }
        if (input) input.placeholder = 'your@email.com';
      }, 4000);
    });
  });

  // ---- SCROLL REVEAL ----
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function(el) { observer.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('visible'); });
  }

  // ---- SMOOTH SCROLL ----
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // ---- KEYBOARD CLOSE ----
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      closeMobileMenu();
      if (searchOverlay) searchOverlay.classList.remove('open');
    }
  });

  // ---- LOOKBOOK DRAG SCROLL ----
  var lookbook = document.querySelector('.lookbook-scroll');
  if (lookbook) {
    var isDown = false, startX, scrollLeft;
    lookbook.addEventListener('mousedown', function(e) {
      isDown = true;
      lookbook.style.cursor = 'grabbing';
      startX = e.pageX - lookbook.offsetLeft;
      scrollLeft = lookbook.scrollLeft;
    });
    lookbook.addEventListener('mouseleave', function() { isDown = false; lookbook.style.cursor = 'grab'; });
    lookbook.addEventListener('mouseup', function() { isDown = false; lookbook.style.cursor = 'grab'; });
    lookbook.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - lookbook.offsetLeft;
      lookbook.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  }

});